<template>
  <div class="sign_in container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="title_input">
        <el-input v-model="form.name" placeholder="请输入标题"></el-input>
      </div>
    </div>
    <div class="main">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="自动结束">
          <el-switch v-model="form.autoStop"></el-switch>
        </el-form-item>
        <el-form-item label="活动时长" v-show="form.autoStop">
          <el-input-number
            size="mini"
            v-model="day"
            :controls="false"
            :min="0"
            :max="29"
          ></el-input-number
          ><span style="margin: 0 20px">天</span>
          <el-input-number
            size="mini"
            v-model="hour"
            :controls="false"
            :min="0"
            :max="23"
          ></el-input-number
          ><span style="margin: 0 20px">小时</span>
          <el-input-number
            size="mini"
            v-model="minute"
            :controls="false"
            :min="0"
            :max="59"
          ></el-input-number
          ><span style="margin: 0 20px">分钟</span>
        </el-form-item>
        <!-- <el-form-item label="定时发放">
          <el-switch
            v-model="form.type"
            active-value="TIMING_SIGN"
            inactive-value="SIGN"
          ></el-switch>
        </el-form-item>
        <div class="timing_box" v-show="form.type == 'TIMING_SIGN'">
          <span style="padding: 0 50px">定时发放</span>
          <el-input-number
            size="mini"
            v-model="timingHour"
            :controls="false"
            :min="0"
            :max="23"
          ></el-input-number
          ><span style="margin: 0 20px">时</span>
          <el-input-number
            size="mini"
            v-model="timingMinute"
            :controls="false"
            :min="0"
            :max="59"
          ></el-input-number
          ><span style="margin: 0 20px">分</span>

          <el-radio-group v-model="form.loop" class="radio_group">
            <el-radio :label="false">仅发一次</el-radio>
            <el-radio :label="true">重复</el-radio>
          </el-radio-group>

          <div v-show="form.loop" class="checkbox_group">
            <el-checkbox v-model="form.loopMon">每周一</el-checkbox>
            <el-checkbox v-model="form.loopTues">每周二</el-checkbox>
            <el-checkbox v-model="form.loopWed">每周三</el-checkbox>
            <el-checkbox v-model="form.loopThur">每周四</el-checkbox>
            <el-checkbox v-model="form.loopFri">每周五</el-checkbox>
            <el-checkbox v-model="form.loopSat">每周六</el-checkbox>
            <el-checkbox v-model="form.loopSun">每周日</el-checkbox>
          </div>
        </div> -->
        <el-form-item class="btn_row">
          <el-button
            type="primary"
            @click="handleSave(true)"
            style="margin-right: 50px"
            >立即开始</el-button
          >
          <el-button @click="handleSave(false)" v-show="form.type == 'SIGN'"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins";
import { formatNumber } from "@/utils";
export default {
  name: "sign",
  mixins: [mixinsData],
  data() {
    return {
      formatNumber,
      form: {
        classChapterId: null,
        classId: null,
        name: "",
        autoStop: true,
        loop: false,
        timingTime: "",
        type: "SIGN",
        duration: null,
        status: "PEND",
        loopMon: false,
        loopTues: false,
        loopWed: false,
        loopThur: false,
        loopFri: false,
        loopSat: false,
        loopSun: false,
      },
      day: 0,
      hour: 0,
      minute: 30,
      timingHour: 0,
      timingMinute: 0,
    };
  },
  deactivated() {
    this.form = this.$options.data().form;
    this.day = this.$options.data().day;
    this.hour = this.$options.data().hour;
    this.minute = this.$options.data().minute;
  },
  computed: {
    duration() {
      return this.day * 24 * 60 + this.hour * 60 + this.minute;
    },
    timingTime() {
      return (
        this.formatNumber(this.timingHour) +
        ":" +
        this.formatNumber(this.timingMinute)
      );
    },
  },
  methods: {
    handleSave(start) {
      this.form.classChapterId = this.$route.query.classChapterId;
      this.form.classId = this.$route.query.id;
      if (start) this.form.status = "STARTED";
      else this.form.status = "PEND";
      this.form.duration = this.duration;
      this.form.timingTime = this.timingTime;
      if (this.$route.query.activityId) {
        // 修改
        this.form.activityId = this.$route.query.activityId;
        this.handleEdit(this.form);
      } else {
        // 新增
        this.handleAdd(this.form);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sign_in {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .title_input {
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
    }
  }
  .main {
    padding: 60px 280px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    text-align: left;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .el-input-number {
      width: 60px;
    }
    .timing_box {
      width: 100%;
      background: #f8f8f8;
      border-radius: 10px;
      margin-top: 10px;
      margin-bottom: 30px;
      padding: 30px 0;
      .radio_group {
        display: block;
        padding: 0 50px;
        .el-radio {
          display: block;
          margin-top: 30px;
        }
      }
      .checkbox_group {
        padding: 0 50px;
        .el-checkbox {
          margin-top: 30px;
        }
      }
    }
    ::v-deep .btn_row {
      text-align: center;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>